'use strict';

var EditNicBond = require('actionGroups/editNicBond/EditNicBond');
var FormView = require('actionGroups/editNicBond/EditNicBondView');

module.exports = {
  Model: EditNicBond,
  GroupView: FormView,
};
